import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

/**
 * Reads the `consultation_booking` site setting and returns whether the
 * "Book Free Consultation" CTAs should be shown.
 *
 * Defaults to `true` while loading or if the setting is missing/errors, so
 * CTAs stay visible rather than flashing hidden.
 */
export const useConsultationEnabled = (): boolean => {
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    let active = true;

    const loadSetting = async () => {
      try {
        const { data, error } = await supabase
          .from("site_settings")
          .select("setting_value")
          .eq("setting_key", "consultation_booking")
          .maybeSingle();

        if (!active) return;

        if (!error && data?.setting_value) {
          const value = data.setting_value as unknown as { enabled?: boolean };
          setEnabled(value.enabled !== false);
        }
      } catch (err) {
        console.error("Error loading consultation setting:", err);
      }
    };

    loadSetting();

    return () => {
      active = false;
    };
  }, []);

  return enabled;
};
